import React, { useState, useEffect, useContext } from "react";
import PropertyBox from "./propertyBox";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { RoleContext } from "../Userdatacontext/Datacontexts";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const path = "/keralaplots/";

//const BASE_URL = "https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImageLow/";
const BASE_URL = "https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/";
function PropertyList() {
   // const [isLoading, setIsLoading] = useState(true);
    const { data, isLoading, fetchpropertydetails, gettokenval } = useContext(RoleContext);


    useEffect(() => {
        //setTimeout(() => {
            //setIsLoading(false);
        //}, 500);
        fetchpropertydetails(); // ✅ Fetch when user logs in
    }, [gettokenval]);

    /**useEffect(() => {
        fetchpropertydetails(); // Fetch properties when component mounts
    
        setTimeout(() => {
            setIsLoading(false);
        }, 2000);
    
        const handlePropertyUpdate = () => {
            fetchpropertydetails();
        };
    
        window.addEventListener("propertyUpdated", handlePropertyUpdate);
    
        return () => {
            window.removeEventListener("propertyUpdated", handlePropertyUpdate);
        };
    }, [fetchpropertydetails]);*/ // ✅ Add dependency
    

    return (
        <>
            <section id="propertyList">
                <div className="container">
                    <h2 className="title">Nearby Listings</h2>
                    <div className="propertyListMain">
                        {isLoading ? (
                            <div className="SkeletonLoader">
                                <Skeleton count={8} />
                            </div>
                        ) : Array.isArray(data) && data.length > 0 ? (
                            
                            data.map((allPropertie) => (
                                <PropertyBox
                                    key={allPropertie.propertyId}
                                    propertyLink={`${path}innerProperty/${allPropertie.propertyId}/${allPropertie.propertyType.replace(
                                        "/",
                                        ""
                                    ).replace(/\s+/g, '-')}-for-${allPropertie.propertyAction === 'sell' ? 'sale' : allPropertie.propertyAction}`}
                                    propertyImage={
                                        allPropertie.imageName
                                            ? `https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImageLow/${allPropertie.imageName}`
                                            : `https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/nophoto.webp`
                                    }
                                    propertyPurposeTag={allPropertie.propertyAction}
                                    propertyId={allPropertie.propertyId}
                                    propertyName={`${allPropertie.propertyType} For ${allPropertie.propertyAction === 'sell' ? 'sale' : allPropertie.propertyAction}`}
                                    propertyLocation={`${allPropertie.district}, ${allPropertie.town}`}
                                    propertyDate={allPropertie.addedDate}
                                    propertyPrice={
                                        allPropertie.priceVisibility === "No"
                                            ? "Not disclosed"
                                            : allPropertie.propertyPricerange
                                    }
                                    propertyType={allPropertie.propertyType}
                                    savedStatus={allPropertie.savedStatus}
                                    addedId={allPropertie.loginId}
                                />
                            ))
                        ) : (
                            <p>No properties available</p>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
}

export default PropertyList;
